export default __webpack_public_path__ + "images/478c5f99bf1e116d5a84fbb9d13cd3ef-newyearseve.webp";